// ConstantsOtherCalculator.js
export const otherCalculators = [
  {
    name: "Generator Kata Sandi",
    link: "/calculator/id/random-password-generator/",
    description:
      "Generator kata sandi, kata sandi kuat, perlindungan akun, keamanan data, keamanan internet, generator kata sandi acak, huruf, angka, dan simbol, pengamanan akun pribadi, buat kata sandi kuat",
    showMain: true,
  },
  {
    name: "Generator Nama",
    link: "/calculator/id/random-name-generator/",
    description:
      "Gunakan generator nama untuk menemukan berbagai nama unik dan indah. Baik Anda mencari nama Arab, Barat, Islam, Timur, mewah, atau langka, generator ini menawarkan berbagai pilihan untuk menemukan nama yang sempurna untuk bayi baru Anda!",
    showMain: true,
  },
  {
    name: "Tes Kecepatan Internet",
    link: "/calculator/id/internet-speed/",
    description:
      "Ukur kecepatan internet, tes kecepatan internet, ukur kecepatan internet sebenarnya, tes kecepatan internet sebenarnya, tes kecepatan internet aktual, ukur kecepatan internet aktual, tes kecepatan internet sebenarnya online, ukur kecepatan internet sebenarnya online",
    showMain: true,
  },
  {
    name: "Generator Angka Acak",
    link: "/calculator/id/random-number-generator/",
    description:
      "Generator angka acak adalah alat yang membantu Anda menghasilkan angka dalam rentang tertentu yang Anda tentukan. Anda dapat memilih batas minimum dan maksimum rentang, dan menentukan jumlah angka acak yang ingin Anda hasilkan.",
    showMain: true,
  },
  {
    name: "Dekorasi Teks",
    link: "/calculator/id/text-decorator/",
    description:
      "Ubah teks biasa menjadi sesuatu yang istimewa. Tambahkan warna, gaya, dan font favorit Anda ke teks Anda. Ideal untuk postingan media sosial, judul, atau sekadar menambahkan sentuhan pribadi.",
    showMain: true,
  },
  {
    name: "Penghitung Istighfar - Tasbih Elektronik",
    link: "/calculator/id/tally-counter/",
    description:
      "Mintalah ampun dengan mudah dan nyaman melalui ponsel Anda. Jadikan istighfar sebagai kebiasaan agar Allah melimpahkan rahmat dan kasih sayang-Nya kepada Anda.",
    showMain: true,
  },
  {
    name: "Kalkulator Waktu Belajar Bahasa Inggris",
    link: "/calculator/id/english-learning-time-calculator/",
    description:
      "Gunakan kalkulator waktu kami untuk menentukan durasi yang tepat yang Anda butuhkan untuk mencapai berbagai tingkat bahasa Inggris, mulai dari pemula (A1) hingga mahir (C2). Dengan alat ini, Anda dapat memperoleh perkiraan waktu yang dipersonalisasi berdasarkan tingkat komitmen Anda, kecepatan belajar, dan faktor pribadi lainnya. Manfaatkan kalkulator ini untuk merencanakan studi Anda dan mencapai tujuan bahasa Anda secara efektif, dengan mempertimbangkan bahwa angka yang diberikan didasarkan pada data Universitas Cambridge tentang perkiraan jam yang diperlukan.",
  },
  {
    name: "Kalkulator Waktu Pengoperasian Baterai - Hitung Jumlah Jam Kerja Baterai",
    link: "/calculator/id/battery-life-calculator/",
    description:
      "Hitung waktu pengoperasian baterai perangkat tertentu berdasarkan kapasitas baterai dan arus yang ditarik perangkat. Kalkulator ini membantu Anda mengetahui berapa lama waktu pengoperasian yang dapat Anda peroleh dari baterai tertentu.",
  },
  {
    name: "Kalkulator Selisih Tinggi Badan Antara Dua Orang",
    link: "/calculator/id/height-difference-calculator/",
    description:
      "Hitung selisih tinggi badan antara dua orang menggunakan kalkulator sederhana ini. Alat ini membantu Anda mengetahui perbedaan pasti dalam tinggi badan antara dua orang saat memasukkan tinggi badan mereka.",
  },
  {
    name: "Penghitung Kata - Hitung Jumlah Kata dalam Teks",
    link: "/calculator/id/word-counter/",
    description:
      "Hitung jumlah kata dalam kalimat tertentu menggunakan kalkulator sederhana ini. Kalkulator ini menyediakan cara cepat dan akurat untuk mengetahui jumlah kata dalam teks apa pun yang Anda tulis.",
  },
  {
    name: "Konversi Mata Uang ke Teks",
    link: "/calculator/id/currency-spreader/",
    description:
      "Hitung nilai sejumlah uang tertentu dalam mata uang pilihan Anda. Kalkulator ini membantu Anda mengetahui nilai uang dalam mata uang yang Anda pilih.",
  },

  {
    name: "Kalkulator Waktu Belajar Bahasa Jerman",
    link: "/calculator/id/german-learning-time-calculator/",
    description:
      "Temukan berapa lama waktu yang mungkin dibutuhkan untuk belajar bahasa Jerman berdasarkan tingkat yang ingin Anda capai.",
  },
  {
    name: "Kalkulator Waktu Belajar Bahasa Prancis",
    link: "/calculator/id/french-learning-time-calculator/",
    description:
      "Temukan berapa lama waktu yang mungkin dibutuhkan untuk belajar bahasa Prancis berdasarkan tingkat yang ingin Anda capai.",
  },
  {
    name: "Kalkulator Jam Ketidakhadiran Mahasiswa",
    link: "/calculator/id/absence-calculator/",
    description:
      "Temukan berapa lama waktu yang mungkin dibutuhkan untuk belajar bahasa Prancis berdasarkan tingkat yang ingin Anda capai.",
  },
  {
    name: "Timer Waktu Elektronik - Penghitung Mundur - Timer Internet",
    link: "/calculator/id/timer/",
    description:
      "Gunakan timer waktu elektronik untuk mengatur waktu dengan mudah. Anda dapat menggunakannya sebagai timer hitung mundur atau penghitung maju. Ideal untuk memasak, olahraga, belajar, atau aktivitas apa pun yang membutuhkan waktu yang tepat.",
  },
];
export default otherCalculators;